import React from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import PaymentActions from '../../redux/reducers/payment_list_reducer/actions';
// import * as PaymentSelectors from 'redux/reducers/payment_list_reducer/selectors';
import useStyles from './styles';
import DatatableList from './components/datatable';
import clsx from 'clsx';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import { TableDefaultFetchValues, Translations } from './configuration';
// import { StateStatus } from 'redux/utils/common';
import * as AuthSelectors from '../../redux/reducers/gl_auth_reducer/selectors';
import { Roles } from 'config';
import useQuery from 'custom_hooks/useQuery';
import NavigationConfig from 'navigation/config';

const PaymentsListPage = (props: any) => {
  // console.log('Render PaymentPage');
  const dispatch = useDispatch();
  const classes = useStyles();
  const ROLE = AuthSelectors.useSelectUserRole();

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const schemeType = query.get('schemeType');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(schemeType && { schemeType }),
  };

  React.useEffect(() => {
    dispatch(
      PaymentActions.setPaymentsAction({
        sortField: TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: TableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize: TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order: TableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  const paymentInfo = () => {
    dispatch(
      PaymentActions.paymentInfoAction({
        onFinish: (success: boolean) => {
          dispatch(
            PaymentActions.setPaymentsAction({
              sortField: TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
              page: TableDefaultFetchValues.TABLE_DEFAULT_PAGE,
              pageSize: TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
              order: TableDefaultFetchValues.TABLE_DEFAULT_ORDER,
            })
          );
        },
      })
    );
  };

  return (
    /*================== Payment List Page ==================*/
    <div>
      {/*================== Payment List Page - Header ==================*/}
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        <div className={classes.header}>
          {/* Payment List Page - Header - Title, Icon & Actions */}
          <Box display="flex" alignItems={'center'}>
            {/* Icon */}
            <AssignmentOutlinedIcon style={{ marginRight: '.75rem' }} />
            {/* Title */}
            <Typography component={'p'} variant={'h6'}>
              <TranslatedText
                textMap={Translations.page_title}
                defaultText={Translations.page_title.English}
              />
            </Typography>
          </Box>
          {ROLE === Roles.Admin && (
            <Box display="flex" alignItems={'center'}>
              <Button className={classes.header_actions} onClick={paymentInfo}>
                <TranslatedText textMap={Translations.payment_info} />
              </Button>
            </Box>
          )}
        </div>
      </Paper>
      {/*--------------- end of Payment List Page - Header ---------------*/}

      {/*================== Payment List Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== Payment List Page - Body - Payment List Section ==================*/}
        <div className={classes.cardLayout}>
          {/* Payment List Page - Body - Payment List Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.table_title}
              defaultText={Translations.table_title.English}
            />
          </Typography>

          {/* Payment List Page - Body - Payment List Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.description}
              defaultText={Translations.description.English}
            />
          </Typography>

          {/* Payment List Page - Body - Payment List Section - Payment List Table */}
          <div className={classes.tableList}>
            <DatatableList />
          </div>

          <Box display="flex" justifyContent="flex-end">
            <div className={classes.dashboardButton}>
              <BackToDashboardPage />
            </div>
          </Box>
        </div>
        {/*--------------- end of Payment List Page - Body - Payment List Section ---------------*/}
      </div>
    </div>
  );
};

const BackToDashboardPage = () => {
  const history = useHistory();
  const goToDashboard = () => {
    history.push(NavigationConfig.dashboardPage().path);
  };

  return (
    <Button
      variant="contained"
      style={{ color: '#e6e6e6', backgroundColor: '#25262d' }}
      onClick={goToDashboard}
    >
      <TranslatedText textMap={Translations.go_to_dashboard} />
    </Button>
  );
};

export default withRouter(PaymentsListPage);
